import React ,{useEffect, useState} from "react";
import TablePagination from "@mui/material/TablePagination";
import { Box, Container, IconButton, Skeleton } from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { TablePaginationActionsProps } from "@mui/material/TablePagination/TablePaginationActions";
import { useTranslation } from "react-i18next";
import PaginationLimitServices from "./services/PaginationLimit";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { commonActions } from "../../../redux/features/common/commonSlice";
import { snackbarUtils } from "../../../utils/snackbarUtils";

const CursorBasedPaginaton = (props: TablePaginationActionsProps & { isCountLoading?: boolean; isPageLoading?: boolean; nextPage?: boolean }) => {
    const { count, page, rowsPerPage, onPageChange, isCountLoading, isPageLoading, nextPage } = props;
    const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

    const handlePreviousPage = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page - 1);
    };

    const handleNextPage = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page + 1);
    };

    if (isPageLoading) {
        return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, ml: 1.5 }}>
                <Skeleton variant="circular" width={24} height={24} animation="wave" />
                <Skeleton variant="circular" width={24} height={24} animation="wave" />
            </Box>
        );
    }

    return (
        <>
            <IconButton
                aria-label="previous page"
                onClick={handlePreviousPage}
                disabled={page === 0}
            >
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton
                aria-label="next page"
                onClick={handleNextPage}
                disabled={isCountLoading ? !nextPage : page >= lastPage}
            >
                <KeyboardArrowRight />
            </IconButton>
        </>
    );
};

const Pagination = (props:any) => {

    const [t, i18n] = useTranslation();

    const {currentPage, totalCount, pageChange, rowsPerPage, rowsPerPageChange, isCountLoading, nextPage, isPageLoading, maxDisplayedCount} = props;
    const dispatch = useAppDispatch();
    const [isPageLimitChange,setIsPageLimitChange]=useState<boolean>(false);

    const loggedInUserType = useAppSelector(
        (state) => state.permission.permissionDetails.userType
    );

    
    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {  
        pageChange(newPage + 1, rowsPerPage);
        // setPage(newPage); 
        // setToggle(!toggle); 
    };

    const showSnackbar = (message: string, success: boolean, autoClose= true) => {
        snackbarUtils(dispatch,message, success, autoClose);
    };
    
    const paginationLimit = () => {
        const payload = {"perPageLimit":rowsPerPage};
        const isHitDummyURL = false;
        new PaginationLimitServices(payload, isHitDummyURL)
            .PaginationLimit()
            .then((res:any) => {
                dispatch(commonActions.SAVE_PER_PAGE_LIMIT(rowsPerPage));
                setIsPageLimitChange(false);
            })
            .catch((err) => {
                showSnackbar(err?.message, false);      
            });
    };

    useEffect(()=>{
        if(location.pathname !== "/inventory-manage" && isPageLimitChange ){
            paginationLimit();
        }
    },[rowsPerPage]);

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setIsPageLimitChange(true);
        rowsPerPageChange(parseInt(event.target.value ));
        pageChange(1, parseInt(event.target.value ));
       
    };

    const actionsComponent = (actionsProps: TablePaginationActionsProps) => (
        <CursorBasedPaginaton
            {...actionsProps}
            isCountLoading={isCountLoading}
            isPageLoading={isPageLoading}
            nextPage={nextPage}
        />
    );

    const labelDisplayedRows = ({ from, to, count }: { from: number; to: number; count: number }) => {
        const displayedCount = count === -1
            ? `more than ${to}`
            : maxDisplayedCount && count > maxDisplayedCount
                ? `${maxDisplayedCount}~`
                : count;
        return `${from}\u2013${to} of ${displayedCount}`;
    };

    return (
        <>
            <Container>
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={currentPage - 1}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={isCountLoading ? [] : [15, 25, 50, 100]}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage={isCountLoading ? <Skeleton variant="rectangular" width={45} height={16} /> : t("table_text.pagination_rows_per_page")}
                    labelDisplayedRows={isCountLoading ? () => <Skeleton variant="rectangular" width={500} height={16} /> : maxDisplayedCount ? labelDisplayedRows : undefined}
                    ActionsComponent={actionsComponent}
                />
            </Container>
        </>
    );
};

export default Pagination;
